export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '试卷名称',
    dataIndex: 'name',
  },
  {
    title: '试卷类型',
    dataIndex: 'use_type',
  },
  {
    title: '试卷描述',
    dataIndex: 'aim',
    scopedSlots: { customRender: 'aim' },
    width: 500,
  },
  {
    title: '试卷详情',
    dataIndex: 'jump_url',
    scopedSlots: { customRender: 'jump_url' },
  },
  {
    title: '问题列表',
    dataIndex: 'question',
    scopedSlots: { customRender: 'question' },
  },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    customRender: (record)=> record.data.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 150,
  },
];
export const questionColumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '问题名称',
    dataIndex: 'paper_title',
  },
  {
    title: '问题类型',
    dataIndex: 'paper_type',
  },
  {
    title: '积分',
    dataIndex: 'score',
  },

  {
    title: '状态',
    customRender: (record)=> record.data.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const serviceFormData = [
	{
		  name: 'company_id',
		  lable: '合作企业',
		  lableCol: 4,
		  wrapperCol: 18,
		  offset: 0,
		  span: 12,
	 },
	{
		  name: 'product_id',
		  lable: '关联产品',
		  lableCol: 4,
		  wrapperCol: 18,
		  offset: 0,
		  span: 12,
	 },
  {
    name: 'name',
    lable: '试卷名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'use_type',
    lable: '试卷类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'aim',
    lable: '试卷描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
export const companyFormData = [
	{
		  name: 'product_id',
		  lable: '关联产品',
		  lableCol: 4,
		  wrapperCol: 18,
		  offset: 0,
		  span: 12,
	 },
  {
    name: 'name',
    lable: '试卷名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'use_type',
    lable: '试卷类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'aim',
    lable: '试卷描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
